import { Layers } from "lucide-react";
import ChildModuleReviewCard from "./ChildModuleReviewCard";

const BaseModuleReviewCard = ({ baseModule, originalBase }) => {
  const childModules = baseModule.SUBSCRIBED_MODULE_DETAILS || [];

  const hasChildModules = childModules.length > 0;

  const basePrice = Number(originalBase?.BASEMODULE_BASEPRICE || 0);

  const subModulesTotal = childModules.reduce((sum, child) => {
    return (
      sum +
      (child?.SUBSCRIBED_SUBMODULE_DETAILS || []).reduce((subSum, sub) => {
        return subSum + Number(sub?.CUSTOM_PRICE || 0);
      }, 0)
    );
  }, 0);

  const total = basePrice + subModulesTotal;

  const modulesData = originalBase?.MODULES_DATA || [];

  return (
    <div className="rounded-3xl overflow-hidden border border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-950/40">
      {/* HEADER */}
      <div className="p-6 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900">
        <div className="flex items-start justify-between gap-5 flex-wrap">
          {/* LEFT */}
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 rounded-2xl flex items-center justify-center bg-gradient-to-br from-teal-500 to-emerald-500 text-white shadow-lg">
              <Layers className="w-5 h-5" />
            </div>

            <div>
              <h5 className="text-lg font-bold text-slate-800 dark:text-white">
                {originalBase?.BASEMODULE_NAME}
              </h5>

              <p className="text-sm mt-2 text-slate-500 dark:text-slate-400">
                {originalBase?.BASEMODULE_DESCRIPTION ||
                  "No description available"}
              </p>
            </div>
          </div>

          {/* RIGHT */}
          <div className="min-w-[170px] rounded-2xl p-4 bg-gradient-to-r from-teal-500 to-emerald-500 text-white shadow-lg">
            <p className="text-xs text-white/80 font-medium">Monthly Total</p>

            <h3 className="text-3xl font-bold mt-1">${total.toFixed(2)}</h3>

            <div className="mt-3 space-y-1 text-xs text-white/80">
              <div className="flex justify-between">
                <span>Base Price</span>
                <span>${basePrice.toFixed(2)}</span>
              </div>

              <div className="flex justify-between">
                <span>Sub Modules</span>
                <span>${subModulesTotal.toFixed(2)}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CHILD MODULES */}
      {hasChildModules && (
        <div className="p-5 space-y-4">
          {childModules.map((child) => {
            const originalChild = modulesData.find(
              (m) => String(m.MODULE_ID) === String(child.MODULE_ID),
            );

            if (!originalChild) return null;

            return (
              <ChildModuleReviewCard
                key={child.MODULE_ID}
                child={child}
                originalChild={originalChild}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default BaseModuleReviewCard;
